<template>
  <div
    :class="[$style.main, 'zk-robot-chat-button']"
    @mouseenter="enterImage"
    @mouseleave="leaveImage"
    @click.capture="openChat"
  >
    <img
      :src="hoverState? botAvatarGif : botAvatar"
      :class="$style.avatar"
    >
  </div>
</template>
<script>
import { defineComponent } from '@vue/composition-api';
import { resolveUrl } from '@zk/framework-vue';

// const transformMessage = (type, result) => {
//   const content = transformContent[type]?.(result);
//   return {
//     id: result.base?.id || result.id || genMessageId(),
//     type,
//     intentCode: result.base?.intentCode,
//     ...(content || {})
//   };
// };
// const processWSMessage = (data, res) => {
//   const { result = {} } = data;
//   const { msgType = '' } = res;
//   const message = transformMessage(msgType, result);
//   receiveMessage(message);
// };

// const socketEvents = {
//   queryAIRightBlock(data, res) {
//     const { result = {} } = data;
//     const { msgType = '' } = res;
//     const message = transformMessage(msgType, result);
//     receiveMessage(message);
//     this.eventBus.$emit('global:openNoAiCreditTip', null, null, 'webIM');
//   },
//   queryAIRecommendData: processWSMessage,
//   queryAIMarkdown: processWSMessage,
//   queryAIReceiveReportData: processWSMessage,
//   queryAIIssue: processWSMessage,
//   queryAINoneData: processWSMessage,
//   queryAIAutomation: processWSMessage,
//   queryAIAutomationError: processWSMessage,
//   queryAIAutomationAskProject: processWSMessage,
//   queryAISprintRiskData: processWSMessage,
//   aiInputText: processWSMessage
// };
export default defineComponent({
  name: 'RobotChatButton',
  props:{
  },
  // socketEvents,
  // shortcutsEvents() {
  //   return [
  //     {
  //       // 16: alt, 18: shift 65: a
  //       key: [16, 18, 65],
  //       type: 'global',
  //       callback: () => {
  //         this.openChat();
  //         this.$track.send(
  //           'Hotkeys',
  //           {
  //             Hotkeys_Scope: '全局',
  //             Hotkeys_Name: 'alt shift a',
  //             Hotkeys_Path: this.$route.path,
  //             Has_Dialog: false
  //           },
  //           true
  //         );
  //       }
  //     }
  //   ];
  // },
  data() {
    return {
      hoverState: false
    };
  },
  computed: {
    botAvatarGif() {
      return require('@/assets/ai-robot/robot-btn.gif');
    },
    botAvatar() {
      return require('@/assets/ai-robot/robot.png');
    }
  },
  microEvents:{
    // 'global:openRobotChat'(from){
    //   this.openRobotChat(from);
    // }
  },
  methods: {
    openChat() {
      // if (isRender.value) {
      //   closeRobotChat(true);
      //   return;
      // }
      // this.eventBus.$emit('leftAside:click');
      // const from = this.$el.classList.contains('driver-highlighted-element') ? 'guide' : undefined;
      // this.openRobotChat(from);
      
      //路由到/chat页面，用window.open打开
      this.eventBus.$emit('finish-guide-task', 'MEET_MY_AI_ASSISTANT_RISK');
      window.open(resolveUrl(`${this.$config.VUE_APP_PMS_URL}/chat`));
    },
    // openRobotChat(from) {
    //   //openRobotChat();
    //   this.$track.send('WebIM_OpenWindow', { Open_Source: from ? '引导打开' : '主动打开' }, true);
    // },
    enterImage() {
      this.hoverState = true;
    },
    leaveImage() {
      this.hoverState = false;
    }
  }
});
</script>
<style lang="scss" module>
.main {
  padding: 0 10px;
  cursor: pointer;
}
.avatar {
  width: 32px;
  height: 32px;
}
</style>
